import { useTranslation } from 'react-i18next'
import React from 'react'

import Tag from '../../packages/kiti/components/presentation/Tag'

const DeletedTag = ({ entity }) => {
  const { t } = useTranslation('components')
  if (entity?.deleted === true) return <Tag label={t('removed')} color="red" transparent size="xsmall" />
  if (entity?.enabled === false) return <Tag label={t('disabled')} color="dark3" transparent size="xsmall" />
  return false
}

export default DeletedTag
